import { useState, useSyncExternalStore } from 'react';
import { Alert, Button, Snackbar } from '@mui/material';
import keycloak from './keycloak';
import { saveBeforeSignIn } from './saveBeforeSignIn';
import {
  getTokenRecoveryState,
  refreshSessionToken,
  subscribeTokenRecovery,
} from './tokenRecovery';

export function SessionRecoveryBanner() {
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<string>();
  const state = useSyncExternalStore(
    subscribeTokenRecovery,
    getTokenRecoveryState,
  );
  if (state === 'ready') return null;
  // Overlays the page so the full-height designer canvas is not resized.
  return (
    <Snackbar open anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Alert
        severity='warning'
        action={
          <Button
            color='inherit'
            disabled={busy}
            onClick={async () => {
              if (state !== 'expired') {
                void refreshSessionToken().catch(() => undefined);
                return;
              }
              setBusy(true);
              setMessage(undefined);
              try {
                await saveBeforeSignIn();
                await keycloak.login();
              } catch {
                setMessage(
                  'Could not prepare sign-in. Save or download your document, then try again.',
                );
              } finally {
                setBusy(false);
              }
            }}
          >
            {state === 'expired' ? 'Sign in' : 'Retry'}
          </Button>
        }
      >
        {message ??
          (state === 'expired'
            ? 'Your session expired. Sign in to continue syncing. Save your edits locally while waiting.'
            : 'We could not renew your session. Syncing may be paused. Please try again.')}
      </Alert>
    </Snackbar>
  );
}
